import React from "react";
import PropTypes from "prop-types";
import {Controller} from "react-hook-form" ;
import ReactHookFormDropdownMessageContacts from "root/ReactHookForm/ui/ReactHookFormDropdownMessageContacts";

const DropdownMessageContacts = ({ validate, control, name, readOnly, options, messageType }) =>
{
    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: true, validate: validate}}
            render={({field: { onChange, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,}) => (
                <ReactHookFormDropdownMessageContacts name={name} onChange={onChange} value={value} inputRef={ref} options={options} readOnly={readOnly} messageType={messageType}/>
            )}/>
    )
}

export default DropdownMessageContacts ;

DropdownMessageContacts.propTypes = {
    name: PropTypes.string.isRequired
};
